import { useBillingUsageLoad } from '@/services/billing/use-billing-usage';
import { deriveUsageMetrics } from '../utils/usage-metrics';

export type BuilderSendRate = {
  /** The per-message rate Builder sends are charged at, in dollars. */
  costPerMessage: number;
  /** Whether the usage the rate comes from has landed. False while the read is disabled. */
  hasSettled: boolean;
};

/**
 * The rate Builder sends are drawn down at, from the account usage. Until it lands the rate is
 * `FALLBACK_BUILDER_CREDIT_COST_PER_MESSAGE`, so a surface never states a rate of its own — a caller
 * that must not quote the fallback (one that snapshots the rate, rather than re-rendering with it)
 * waits for `hasSettled`.
 *
 * The load is silent and skippable: it is read by surfaces that show the rate as a caption, and a
 * snackbar about usage would not belong on any of them. Pass `enabled: false` where the rate is not
 * shown at all, so no request is made.
 */
export function useBuilderSendRate(options?: { enabled?: boolean }): BuilderSendRate {
  const load = useBillingUsageLoad({ silent: true, enabled: options?.enabled });

  return {
    costPerMessage: deriveUsageMetrics(load.usage).builderCreditCostPerMessage,
    hasSettled: load.hasSettled,
  };
}
